import React from 'react';

/* Rang-Namen: ab "Double/Triple Diamond Elite" zweizeilig —
   "Double" / "Diamond Elite" (User-Wunsch). */
export default function RankName({ name }) {
  const m = /^(Double|Triple)\s+(.+)$/.exec(name || '');
  if (!m) return <>{name}</>;
  return (
    <>
      {m[1]}
      <br />
      {m[2]}
    </>
  );
}
